import { Injectable } from '@angular/core';
import { AgencyOfficerDetailsFacade, AgencyOfficerDetailsPermissions } from '@intrensic/agency-management/data-access';
import { LoggedInOfficer, OfficerDetailFacade } from '@intrensic/shared/officer-details';
import { Observable, combineLatest, filter, first, map, pairwise } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UpdateLoggedInOfficerService {
  constructor(private officerDetailsFacade: OfficerDetailFacade, private agencyOfficerDetailsFacade: AgencyOfficerDetailsFacade) {}

  public updateLoggedInOfficerDetails(): Observable<Record<string, never>> {
    return combineLatest<[LoggedInOfficer, AgencyOfficerDetailsPermissions]>([
      this.officerDetailsFacade.getLoggedInOfficer().pipe(first()),
      this.agencyOfficerDetailsFacade.getAgencyOfficerDetails().pipe(
        pairwise(),
        filter(
          ([previous, current]) =>
            previous.agencyOfficerDetails.uid === current.agencyOfficerDetails.uid &&
            (previous.agencyOfficerDetails.firstName !== current.agencyOfficerDetails.firstName ||
              previous.agencyOfficerDetails.lastName !== current.agencyOfficerDetails.lastName ||
              previous.agencyOfficerDetails.emailAddress !== current.agencyOfficerDetails.emailAddress ||
              previous.agencyOfficerDetails.role !== current.agencyOfficerDetails.role ||
              previous.agencyOfficerDetails.shareType !== current.agencyOfficerDetails.shareType ||
              previous.agencyOfficerDetails.timeZone !== current.agencyOfficerDetails.timeZone ||
              previous.agencyOfficerPermissions.canDownloadFiles !== current.agencyOfficerPermissions.canDownloadFiles)
        ),
        map(([, current]) => current)
      ),
    ]).pipe(
      map(([loggedInOfficer, agencyOfficer]) => {
        if (loggedInOfficer.uid === agencyOfficer.agencyOfficerDetails.uid) {
          this.officerDetailsFacade.updateLoggedInOfficer();
        }

        return {};
      })
    );
  }
}
